import { render, staticRenderFns } from "./f-phone.vue?vue&type=template&id=d88a78ec&lang=pug&"
import script from "./f-phone.vue?vue&type=script&lang=js&"
export * from "./f-phone.vue?vue&type=script&lang=js&"
import style0 from "./f-phone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d88a78ec')) {
      api.createRecord('d88a78ec', component.options)
    } else {
      api.reload('d88a78ec', component.options)
    }
    module.hot.accept("./f-phone.vue?vue&type=template&id=d88a78ec&lang=pug&", function () {
      api.rerender('d88a78ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-phone.vue"
export default component.exports